<template lang="pug">
.user-management
  .with-actions
    h1 用户管理
    .ui.buttons.actions
      .ui.basic.button(@click='create_user()')
        i.add.icon.themed.text.inline
        span.themed.text 添加用户

  auto-table(:defines='$defines.user', :data='formartted_users', actions='edit', unstackable, @action:edit='edit_user')

  el-dialog(:visible.sync='dialog_visible', :close-on-click-modal='false')
    form-user(:user='dialog_user', @exit='edit_exit')
</template>

<script>
import { MakeFetcher } from '../../utils'
import { AutoTable } from '../../components/auto'
import { FormUser } from '../../components/forms'

export default {
  name: 'user-management',
  components: { AutoTable, FormUser },
  data() {
    return {
      users: [],
      selected: [],
      dialog_user: undefined,
      dialog_visible: false,
    }
  },
  computed: {
    roles() {
      return this.$store.state.summary.roles
    },
    formartted_users() {
      return this.users.map(({ roles, ...others }) => {
        const roles_names = []
        for (const current of roles) {
          const role = this.roles.filter(r => r._id === current)[0]
          if (role)
            roles_names.push(role.name)
        }
        return {
          _roles: roles_names.join(','),
          roles,
          ...others,
        }
      })
    },
  },
  mounted() {
    this.fetch_roles()
    this.fetch_users()
  },
  methods: {
    fetch_users: MakeFetcher({
      url: 'users',
      key: 'users',
    }),
    fetch_roles() {
      this.$store.dispatch('load_roles')
    },
    edit_user(user) {
      this.dialog_user = user
      this.dialog_visible = true
    },
    create_user() {
      this.dialog_user = undefined
      this.dialog_visible = true
    },
    edit_exit() {
      this.dialog_visible = false
      this.fetch_users()
    },
  },
}
</script>



// WEBPACK FOOTER //
// UserManagement.vue?7e32e066